import { render, staticRenderFns } from "./error.vue?vue&type=template&id=cb4d8976&scoped=true&"
var script = {}
import style0 from "./error.vue?vue&type=style&index=0&id=cb4d8976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4d8976",
  null
  
)

export default component.exports